module.exports = __webpack_public_path__ + "img/loading3.69575219.svg";